export default "__VITE_ASSET__f5e26a1a__"